module.exports = __webpack_public_path__ + "static/Bierpong_x264-cd56e421dd45a9b3b37eb8e3c20b31a8.mp4";